/**
 * EnemyHealthBar — pure floating-bar state logic (no Phaser).
 *
 * Color tier: white > 60 %, yellow 30–60 %, red < 30 %.
 * Bar visible once the enemy has taken any damage and is not KO'd.
 */

export const BAR_COLOR_FULL = 0xffffff; // healthy  (> 60 %)
export const BAR_COLOR_MID = 0xffdd00; // hurt     (30–60 %)
export const BAR_COLOR_LOW = 0xff3333; // critical (< 30 %)

/** Return the tint colour for a floating HP bar at `hpFrac`. */
export function enemyBarColor(hpFrac: number): number {
  if (hpFrac > 0.6) return BAR_COLOR_FULL;
  if (hpFrac > 0.3) return BAR_COLOR_MID;
  return BAR_COLOR_LOW;
}

export interface FloatingBarState {
  visible: boolean;
  /** 0..1, clamped. */
  hpFrac: number;
  color: number;
}

/**
 * Compute the display state for a single floating HP bar.
 *
 * Hidden until `everDamaged` is true (bar appears on first hit, not on spawn).
 * Immediately hidden when `isKO` regardless of damage state.
 */
export function floatingBarState(
  hpFrac: number,
  isKO: boolean,
  everDamaged: boolean,
): FloatingBarState {
  const clamped = Math.max(0, Math.min(1, hpFrac));
  return {
    visible: !isKO && everDamaged,
    hpFrac: clamped,
    color: enemyBarColor(clamped),
  };
}
